// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bxdg","badges":"styles_badges__BS5Am"};